import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "clearfix component-tree-node" };
const _hoisted_2 = ["id"];
const _hoisted_3 = {
    key: 0,
    class: "float-start left5"
};
const _hoisted_4 = { class: "float-start" };
const _hoisted_5 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ComponentTreeVue = _resolveComponent("ComponentTreeVue");
    return (_openBlock(), _createElementBlock("li", null, [
        _createElementVNode("div", _hoisted_1, [
            (_ctx.hasChildren)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "float-start right5",
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.expand && _ctx.expand(...args)))
                }, [
                    _createElementVNode("i", {
                        class: _normalizeClass(['fa font14', _ctx.isExpanded ? 'fa-chevron-down' : 'fa-chevron-right'])
                    }, null, 2 /* CLASS */)
                ]))
                : _createCommentVNode("v-if", true),
            _cache[4] || (_cache[4] = _createTextVNode()),
            _createElementVNode("div", {
                id: 'component-' + _ctx.item.componentId,
                class: "item-row",
                onClick: _cache[1] || (_cache[1] =
                    //@ts-ignore
                    (...args) => (_ctx.toggleSelect && _ctx.toggleSelect(...args)))
            }, [
                (_ctx.selectable)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("i", {
                            class: _normalizeClass(_ctx.checkBoxCssClass)
                        }, null, 2 /* CLASS */)
                    ]))
                    : _createCommentVNode("v-if", true),
                _cache[3] || (_cache[3] = _createTextVNode()),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("span", {
                        class: _normalizeClass(_ctx.cssClass)
                    }, [
                        _renderSlot(_ctx.$slots, "content", _normalizeProps(_guardReactiveProps(_ctx.item)), () => [
                            _createTextVNode("\r\n\t\t\t\t\t\t\t " + _toDisplayString(_ctx.item.displayName), 1 /* TEXT */)
                        ])
                    ], 2 /* CLASS */)
                ])
            ], 8 /* PROPS */, _hoisted_2)
        ]),
        _cache[5] || (_cache[5] = _createTextVNode()),
        (_ctx.hasChildren)
            ? _withDirectives((_openBlock(), _createElementBlock("ul", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.children, (child, index) => {
                    return (_openBlock(), _createBlock(_component_ComponentTreeVue, {
                        ref_for: true,
                        ref: "children",
                        key: child.componentId,
                        item: child,
                        "parent-id": _ctx.item.componentId,
                        selectable: _ctx.selectable,
                        "selected-nodes": _ctx.selectedNodesModel,
                        "onUpdate:selectedNodes": _cache[2] || (_cache[2] = ($event) => ((_ctx.selectedNodesModel) = $event))
                    }, {
                        content: _withCtx((child) => [
                            _renderSlot(_ctx.$slots, "content", _mergeProps({ ref_for: true }, child), () => [
                                _createTextVNode("\r\n\t\t\t\t\t\t " + _toDisplayString(child.displayName), 1 /* TEXT */)
                            ])
                        ]),
                        _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["item", "parent-id", "selectable", "selected-nodes"]));
                }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */)), [
                [_vShow, _ctx.isExpanded]
            ])
            : _createCommentVNode("v-if", true)
    ]));
}
